// import { ReactComponent as FbIcon } from "../assets/facebook_icon.svg";
// import { ReactComponent as InstaIcon } from "../assets/instagram_icon.svg";
// import { ReactComponent as YtIcon } from "../assets/youtube.svg";

export const next_sec_support = {
  Pending: [
    "Planned",
    "Scripting In Process",
    "Dropped",
    "Under Video Edit",
    "Scripting Approved",
    "Pending",
    "Voice over Artist",
    "Under Graphic Edit",
    "Shared",
  ],
  Planned: [
    "Pending",
    "Scripting In Process",
    "Under Video Edit",
    "Voice over Artist",
    "Under Graphic Edit",
  ],
  "Scripting In Process": ["Pending", "Scripting Under Review"],
  "Scripting Under Review": [
    "Pending",
    "Scripting In Process", // if rejected
    "Scripting Approved", // if approved
  ],
  "Scripting Approved": [
    "Pending",
    "Under Video Edit",
    "Voice over Artist",
    "Under Graphic Edit",
    "Approved",
  ],
  "Under Video Edit": ["Pending", "Under Img/Video Review"],
  "Voice over Artist": ["Pending", "Under Img/Video Review"],
  "Under Graphic Edit": ["Pending", "Under Img/Video Review"],
  "Under Img/Video Review": [
    "Pending",
    "Approved", // if passed
    // respective edit section again if rejected (add as needed)
    "Under Video Edit",
    "Voice over Artist",
    "Under Graphic Edit",
  ],
  Approved: ["Pending", "Shared", "Dropped"],
  Shared: ["Pending", "Dropped"],
  Dropped: [
    "Pending",
    "Planned",
    "Scripting In Process",
    "Scripting Under Review",
    "Scripting Approved",
    "Under Video Edit",
    "Voice over Artist",
    "Under Graphic Edit",
    "Under Img/Video Review",
    "Approved",
    "Shared",
  ],
};

export const sectionIdToName = {
  1: "Planned",
  2: "Scripting In Process",
  6: "Dropped",
  3: "Under Video Edit",
  4: "Under Img/Video Review",
  9: "Scripting Under Review",
  11: "Pending",
  14: "Voice over Artist",
  15: "Under Graphic Edit",
  16: "Shared",
  5: "Approved",
  12: "Scripting Approved",
};

export const POST_STATUS_OPTIONS = [
  { id: 1, name: "Scheduled", value: "SCHEDULED" },
  { id: 2, name: "Queued", value: "QUEUED" },
  { id: 3, name: "Failed", value: "FAILED" },
  { id: 4, name: "Published", value: "PUBLISHED" },
  { id: 5, name: "Cancelled", value: "CANCELLED" },
  { id: 6, name: "Deleted", value: "DELETED" },
  { id: 7, name: "Updated", value: "UPDATED" },
  { id: 8, name: "Partial posted", value: "PARTIAL_POSTED" },
];

export const TASK_STEPS = {
  BASIC_DETAILS: 0,
  USER: 1,
  REFERENCES: 2,
  CAPTION_SCRIPT: 3,
  COMMENT_HISTORY: 4,
  ATTACHMENTS: 5,
  CONTENT_APPROVAL: 6,
  PUBLISH_PREVIEW: 7,
  LINKS: 8,
};

export const APPROVAL_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const getApprovalStatusLabel = (statusId) => {
  const statusLabels = {
    [APPROVAL_STATUS.PENDING]: "Pending",
    [APPROVAL_STATUS.APPROVED]: "Approved",
    [APPROVAL_STATUS.REJECTED]: "Rejected",
  };
  return statusLabels[statusId] || "Unknown";
};

export const getApprovalStatusBgColor = (statusId) => {
  const statusColors = {
    [APPROVAL_STATUS.PENDING]: "#FFF7ED",
    [APPROVAL_STATUS.APPROVED]: "#D1FAE5",
    [APPROVAL_STATUS.REJECTED]: "#FEE2E2",
  };
  return statusColors[statusId] || "#F3F4F6";
};

export const POST_TYPE = {
  REEL: 1,
  VIDEO: 2,
  IMAGE: 3,
};

const POST_TYPE_LABELS = {
  [POST_TYPE.REEL]: "Reel",
  [POST_TYPE.VIDEO]: "Video",
  [POST_TYPE.IMAGE]: "Image",
};

export const getPostTypeLabel = (postTypeId) => {
  return POST_TYPE_LABELS[postTypeId] || "-";
};

export const PLATFORM = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  YOUTUBE: 4,
};

const PLATFORM_LABELS = {
  [PLATFORM.FACEBOOK]: "Facebook",
  [PLATFORM.INSTAGRAM]: "Instagram",
  [PLATFORM.YOUTUBE]: "YouTube",
};

export const getPlatformLabel = (platformId) => {
  return PLATFORM_LABELS[platformId] || "-";
};

export const STATUS = {
  SCHEDULED: 1,
  QUEUED: 2,
  FAILED: 3,
  PUBLISHED: 4,
  CANCELLED: 5,
  DELETED: 6,
  UPDATED: 7,
  PARTIAL_POSTED: 8,
};

const STATUS_LABELS = {
  [STATUS.SCHEDULED]: "Scheduled",
  [STATUS.QUEUED]: "Queued",
  [STATUS.FAILED]: "Failed",
  [STATUS.PUBLISHED]: "Published",
  [STATUS.CANCELLED]: "Cancelled",
  [STATUS.DELETED]: "Deleted",
  [STATUS.UPDATED]: "Updated",
  [STATUS.PARTIAL_POSTED]: "Partial posted",
};

export const getStatusLabel = (statusId) => {
  return STATUS_LABELS[statusId] || "--";
};

export const sectionNameToId = Object.fromEntries(
  Object.entries(sectionIdToName).map(([id, name]) => [name, Number(id)]),
);

export const user_new_role_to_old_role = {
  content_writer: [2, 5], // content writer & comms generalist
  designer: [1, 3, 4], // video editor, voice over artist, graphic designer
};

export const section_move_permissions = {
  Pending: [],
  Planned: ["content_writer"],
  "Scripting In Process": ["content_writer"],
  "Scripting Under Review": [],
  "Scripting Approved": [],
  "Under Video Edit": ["designer"],
  "Voice over Artist": ["designer"],
  "Under Graphic Edit": ["designer"],
  "Under Img/Video Review": [],
  Approved: ["content_writer"],
  Shared: [],
  Dropped: [],
};

export const Platforms = [
  { id: 1, name: "Facebook" },
  { id: 2, name: "Instagram" },
  { id: 4, name: "Youtube" },
];

// export const Platforms = [
//   { id: "Facebook", name: "Facebook", icon: <FbIcon /> },
//   { id: "Instagram", name: "Instagram", icon: <InstaIcon /> },
//   { id: "Youtube", name: "YouTube", icon: <YtIcon /> },
// ];

export const sections = [
  "Pending",
  "Planned",
  "Scripting In Process",
  "Scripting Under Review",
  "Scripting Approved",
  "Under Video Edit",
  "Voice over Artist",
  "Under Graphic Edit",
  "Under Img/Video Review",
  "Approved",
  "Shared",
  "Dropped",
];

export const getDefaultColors = () => {
  return {
    section: {
      1: "#1DA1F2", // Planned
      2: "#F39237", // Scripting In Process
      6: "#FE5F55", // Dropped
      3: "#F39237", // Under Video Edit
      4: "#F39237", // Under Img/Video Review
      9: "#F39237", // Scripting Under Review
      11: "#53063eff", // Pending
      14: "#F39237", // Voice over Artist
      15: "#F39237", // Under Graphic Edit
      16: "#68C066", // Shared
      5: "#68C066", // Approved
      12: "#68C066", // Scripting Approved
    },

    type: {
      1: "#6E6C6B", // Third Party
      2: "#B8B8B8", // Adhoc – Third Party
      3: "#FFB800", // Party
      4: "#8C30F5", // Adhoc – Party
    },
  };
};

export const status_id_mappings = {
  1: { name: "Pending", bgColor: "#D4E7F6" },
  2: { name: "Approved", bgColor: "#CAF0CC" },
  3: { name: "Rejected", bgColor: "#FABBC3" },
};

// Step mapping: keys to check per page/step
export const stepwise_keys_for_normalization = {
  0: [
    "title",
    "project",
    "property",
    "cohort",
    "format",
    "type",
    "due_at",
    "schedule_time",
    "selected_pages",
  ],
  1: ["approver", "content_writer", "designer"],
  3: ["description"],
  8: [
    "post_link",
    "ig_post_link",
    "yt_post_link",
    "burner_fb_post_link",
    "burner_ig_post_link",
    "burner_yt_post_link",
  ],
};

export const localStorageKeys = {
  WORKBOARD_FILTERS: "workboard_filters",
};

export const status_to_activeStep = {
  Pending: 0,
  Planned: 0,
  "Scripting In Process": 3,
  "Scripting Under Review": 3,
  "Scripting Approved": 3,
  "Under Video Edit": 5,
  "Voice over Artist": 5,
  "Under Graphic Edit": 5,
  "Under Img/Video Review": 6,
  Approved: 7,
  Shared: 8,
  Dropped: 0,
};

export const loader_ids = {
  TASK_CREATE: "task_create_loader",
  UPDATE_TASK_DATA: "update_task_data",
  FETCH_TASK_DATA: "fetch_task_data",
  FETCH_TASK_ATTACHMENTS: "fetch_task_attachments",
  TASK_STATUS_UPDATE: "task_status_update",
  FETCH_COMMENT_OR_SCRIPT: "fetch_comments_or_scripts",
  FETCH_SECTION_TASKS: "fetch_section_tasks",
  USER_PREFERENCES: "user_preferences_loader",
  USER_PREFERENCES_CREATE_UPDATE: "user_preferences_create_update_loader",
  REPO_SEARCH_BASIC_DETAILS: "repository_search_basic_details_loader",
  REPO_SEARCH_REFERENCES: "repository_search_references_loader",
  REPO_SEARCH_SCRIPTS: "repository_search_scripts_loader",
};

export const default_views = [
  {
    id: 1000000,
    name: "Content Writer",
    statuses: [
      { id: 2, status: "Scripting In Process" },
      { id: 9, status: "Scripting Under Review" },
      { id: 12, status: "Scripting Approved" },
    ],
  },
  {
    id: 1000001,
    name: "Graphic Designer",
    statuses: [
      { id: 3, status: "Under Video Edit" },
      { id: 15, status: "Under Graphic Edit" },
      { id: 4, status: "Under Img/Video Review" },
      { id: 5, status: "Approved" },
    ],
  },
  {
    id: 1000002,
    name: "Voice Over Artist",
    statuses: [
      { id: 12, status: "Scripting Approved" },
      { id: 14, status: "Voice over Artist" },
      { id: 5, status: "Approved" },
    ],
  },
];

export const ATTACHMENTS_PLATFORM_MAPPING = {
  facebook: 3,
  instagram: 1,
  youtube: 2,
};
